import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleLeft, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { SelectImageData } from "../../../utils/common";
import { useNavigate } from "react-router";
import Header from "../../Header/Header";
import VarientSection from "./Varient";
import { useParams } from "react-router-dom";
import { useWatch } from "react-hook-form";
library.add(fas);

const EditVariant = ({
  key,
  errors,
  register,
  control,
  index,
  getValues,
  watch,
  variant,
  reset,
  setValue,
}) => {
  // const id = props.show;
  const { id } = useParams();
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);

  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");

    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  const weekData = useWatch({
    name: `quantitys.${index}`,
    control,
  });

  const total = (weekData?.varients || []).reduce((acc, v) => {
    const general = parseFloat(v.general_stock) || 0;
    const subscription = parseFloat(v.subscription_stock) || 0;
    return acc + general + subscription;
  }, 0);

  // useEffect(() => {
  //   setValue(`quantitys.${index}.receive_quantity`, total);
  // }, [total, index, setValue]);

  return (
    <div key={variant.id} className="main-form-section mt-3">
      <Row>
        <Col md={4}>
          <div className="main-form-section mt-3">
            <Row className="justify-content-center">
              <Form.Label>Product</Form.Label>
              <Form.Group>
                <Controller
                  name={`quantitys.${index}.product_id`} // name of the field
                  {...register(`quantitys.${index}.product_id`, {
                    required: "Select Product",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors?.add_on?.[index]?.product_id
                            ? "red"
                            : baseStyles,
                        }),
                      }}
                      {...field}
                      options={product}
                    />
                  )}
                />
                {errors?.quantitys?.[index]?.product_id && (
                  <span className="text-danger">
                    {errors.quantitys[index].product_id.message}
                  </span>
                )}
              </Form.Group>
            </Row>
          </div>
        </Col>
        <Col md={4}>
          <div className="main-form-section mt-3">
            <Row className="justify-content-center">
              <Form.Label>Purchase Quantity</Form.Label>
              <Form.Group>
                <Form.Control
                  type="text"
                  name={`quantitys.${index}.quantity`} // Register color for the variant
                  placeholder="Quanitity"
                  readOnly
                  className={classNames("", {
                    "is-invalid": errors?.quantitys?.[index]?.quantity,
                  })}
                  {...register(`quantitys.${index}.quantity`, {
                    required: "Quanitity is required",
                  })}
                  onKeyDown={(e) => {
                    const invalidKeys = ["e", "E", "+", "-", ".", ","];

                    // Allow Backspace, Arrow keys
                    if (
                      e.key === "Backspace" ||
                      e.key === "ArrowLeft" ||
                      e.key === "ArrowRight" ||
                      e.key === "Tab"
                    ) {
                      return;
                    }

                    // Block ".", letters, symbols, negative, decimal
                    if (invalidKeys.includes(e.key)) {
                      e.preventDefault();
                    }

                    // Block anything that is NOT a number 1–9
                    if (!/^[0-9]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors?.quantitys?.[index]?.quantity && (
                  <span className="text-danger">
                    {errors.quantitys[index].quantity.message}
                  </span>
                )}
              </Form.Group>
            </Row>
          </div>
        </Col>

        <Col md={4}>
          <div className="main-form-section mt-3">
            <Row className="justify-content-center">
              <Form.Label>Recevie Quantity</Form.Label>
              <Form.Group>
                <Form.Control
                  // readOnly
                  type="text"
                  name={`varients.${index}.receive_quantity`}
                  // value={total}
                  placeholder="Quanitity"
                  className={classNames("", {
                    "is-invalid": errors?.quantitys?.[index]?.receive_quantity,
                  })}
                  {...register(`quantitys.${index}.receive_quantity`, {
                    required: "Quanitity is required",
                  })}
                  onKeyDown={(e) => {
                    if (
                      e.key === "Backspace" ||
                      e.key === "ArrowLeft" ||
                      e.key === "ArrowRight"
                    ) {
                      return;
                    }

                    if (!/[\d.]/.test(e.key)) {
                      e.preventDefault();
                    }

                    if (e.key === "." && e.target.value.includes(".")) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors?.quantitys?.[index]?.receive_quantity && (
                  <span className="text-danger">
                    {errors.quantitys[index].receive_quantity.message}
                  </span>
                )}
              </Form.Group>
            </Row>
          </div>
        </Col>

        <Col md={4}>
          <div className="main-form-section mt-3">
            <Row className="justify-content-center">
              <Form.Label>Purchase Price</Form.Label>
              <Form.Group>
                <Form.Control
                  type="text"
                  name={`quantitys.${index}.price`} // Register color for the variant
                  placeholder="Purchase Price"
                  className={classNames("", {
                    "is-invalid": errors?.quantitys?.[index]?.price,
                  })}
                  {...register(`quantitys.${index}.price`, {
                    required: "price is required",
                  })}
                  onKeyDown={(e) => {
                    if (
                      e.key === "Backspace" ||
                      e.key === "ArrowLeft" ||
                      e.key === "ArrowRight"
                    ) {
                      return; // Allow the action to continue
                    }

                    // Allow digits and decimal point
                    if (!/[\d.]/.test(e.key)) {
                      e.preventDefault(); // Block the invalid key
                    }

                    if (e.key === "." && e.target.value.includes(".")) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors?.quantitys?.[index]?.price && (
                  <span className="text-danger">
                    {errors.quantitys[index].price.message}
                  </span>
                )}
              </Form.Group>
            </Row>
          </div>
        </Col>

        <Col md={4}>
          <div className="main-form-section mt-3">
            <Row className="justify-content-center">
              <Form.Label>Total</Form.Label>
              <Form.Group>
                <Form.Control
                  type="text"
                  name={`quantitys.${index}.total_price`}
                  value={(() => {
                    const receiveQty =
                      parseFloat(
                        watch(`quantitys.${index}.receive_quantity`)
                      ) || 0;
                    const price =
                      parseFloat(watch(`quantitys.${index}.price`)) || 0;
                    return (receiveQty * price).toFixed(2);
                  })()}
                  readOnly
                  className={classNames("", {
                    "is-invalid": errors?.quantitys?.[index]?.total_price,
                  })}
                />
                {errors?.quantitys?.[index]?.total_price && (
                  <span className="text-danger">
                    {errors.quantitys[index].total_price.message}
                  </span>
                )}
              </Form.Group>
            </Row>
          </div>
        </Col>

        {/* <Col md={4}>
          <div className="main-form-section mt-3">
            <Row className="justify-content-center">
              <Form.Label>Expiry Date</Form.Label>
              <Form.Group>
                <Form.Control
                  type="date"
                  name={`quantitys.${index}.expiry_date`}
                  placeholder="Quantity"
                  className={classNames("", {
                    "is-invalid": errors?.quantitys?.[index]?.expiry_date,
                  })}
                  min={new Date().toISOString().split("T")[0]} // disable past dates in picker
                  {...register(`quantitys.${index}.expiry_date`, {
                    required: "Expiry Date is required",
                    validate: (value) => {
                      const selectedDate = new Date(value);
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);
                      return (
                        selectedDate > today ||
                        "Expiry Date must be in the future"
                      );
                    },
                  })}
                  onBlur={(e) => {
                    const value = e.target.value;
                    if (value) {
                      const selectedDate = new Date(value);
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);
                      if (selectedDate <= today) {
                        e.target.blur(); // remove focus from the input if past date is entered
                      }
                    }
                  }}
                />

                {errors?.quantitys?.[index]?.expiry_date && (
                  <span className="text-danger">
                    {errors.quantitys[index].expiry_date.message}
                  </span>
                )}
              </Form.Group>
            </Row>
          </div>
        </Col> */}

        <VarientSection
          product_id={getValues(`quantitys.${index}.product_id`)}
          weekIndex={index}
          control={control}
          register={register}
          getValues={getValues}
          errors={errors}
          setValue={setValue}
        />
      </Row>

      <hr />
    </div>
  );
};

export default EditVariant;
